<template>
    <v-row justify="center">
    <v-dialog v-model="dialogLocal" width="750">
      <v-card>
        <v-form ref="es" action="#" lazy-validation>
        <v-card-title class="justify-space-between" :style="{'background-color': topbarcolor}" style="color: white; padding-top: 5px; padding-bottom: 5px">
          <span class="headline">Gate Ref: {{modalInfo.RefGateID}}</span>
          <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-overlay
                :absolute="true"
                :opacity="1"
                :z-index="999"
                :value="modal_loader"
                color="#D2D7DF"
                >
                <v-progress-circular indeterminate size="100"></v-progress-circular>
            </v-overlay>
            <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>{{props.item.GateID}}</td>
                            <td>{{props.item.RefGateID}}</td>
                            <td>
                                <v-chip
                                x-small
                                class="ma-2"
                                :color="showConnect(props.item.lastSeenDate, 'color')"
                                text-color="white">
                                    {{showConnect(props.item.lastSeenDate, 'text')}}
                                </v-chip>
                            </td>
                            <td>{{props.item.lastSeenDate2}}</td>
                        </tr>
                    </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    </v-row>
</template>

<script>
import * as moment from "moment";
import * as tz from "moment-timezone";

  export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master'],

    data() {
        return {
            dialogLocal: false,
            items: [],
            /*31. Controller ID, Controller Ref., Last Seen, Date Last Seen -> display N/A if no value -> {{url}}/api/gatecontroller/view/bygatecontrollerid :warning:  */
            headers: [
                { text: '#', value: 'row', width: '3%' },
                { text: 'Gate ID', value: 'GateID', width: '3%' },
                { text: 'Gate Ref', value: 'RefGateID', width: '3%' },
                { text: 'Last Seen', value: 'LastSeen', width: '3%' },
                { text: 'Date Last Seen', value: 'lastSeenDate2', width: '12%', sort: function (a, b) {
                    let aa = moment(a, 'DD-MM-YYYY hh:mm:ss A');
                    let aa2 = aa.toDate();

                    let bb = moment(b, 'DD-MM-YYYY hh:mm:ss A');
                    let bb2 = bb.toDate();

                    return aa2 > bb2 ? -1 : aa2 < bb2 ? 1 : 0;
                }  },
            ],
            tableloading: false,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            page: 1,
            modal_loader: true,
            amount_due_color: '',
            topbarcolor: JSON.parse(localStorage.getItem('theme')).topbarcolor
        }
    },

    watch: {
        dialog: {
        handler: function(value) {
            this.modalHandler();
            if(value == true){
                this.handleValue();
            }
        },
        },

        dialogLocal: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    methods: {
        async listAll(){
            this.items = [];
            this.tableloading = true;
            this.modal_loader = true;

            let response = await this.$store.dispatch('getGateByID', {gateid: this.modalInfo.GateID})
            if (response.data.code == "AP000"){
                let dt = response.data.record;

                for(var i=0; i<dt.length; i++){
                    dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                    dt[i].lastSeenDate2 = dt[i].lastSeenDate == null ? "N/A" : moment.unix(dt[i].lastSeenDate).format('DD-MM-YYYY hh:mm:ss A');
                }

                this.items = dt;
            }

            this.tableloading = false;
            this.modal_loader = false;
        },

        modalHandler(){
            this.dialogLocal = !this.dialogLocal;
        },

        modalCloseHandler(){
            if (this.dialogLocal == false){
                this.$emit('closed', false);
            }
        },

        handleValue(){
            this.listAll();
            /*
            this.items.parkerID = this.modalInfo.parkerID;
            this.items.name = this.modalInfo.name;
            this.items.mobile = this.modalInfo.mobile;
            this.items.email = this.modalInfo.email;
            */
        },

        showConnect(item, typ){
            if (typ == 'text'){
                    if ((Math.round((new Date()).getTime() / 1000) - item) / 60 <= 5)
                        return 'Connected';

                    else
                        return 'Disconnected';
            }

            if (typ == 'color'){
                    if ((Math.round((new Date()).getTime() / 1000) - item) / 60 <= 5)
                        return 'green';

                    else
                        return 'red';
            }
        },
    }
  }
</script>